import { IDENTITY_MATRIX, invertMatrix, multiplyMatrix, type Matrix } from './geometry';
import { findLayer, findLayerParent, layerParentTransform, type EditorDocument } from './model';

export type VectorDrawMode = 'normal' | 'behind' | 'inside';

export interface VectorDrawPlacement {
  parentId: string;
  index: number;
  clipping: boolean;
  parentTransform: Matrix;
  effectiveMode: VectorDrawMode;
}

const normalPlacement = (): VectorDrawPlacement => ({
  parentId: 'root',
  index: 0,
  clipping: false,
  parentTransform: IDENTITY_MATRIX,
  effectiveMode: 'normal',
});

export function vectorDrawPlacement(document: EditorDocument, mode: VectorDrawMode): VectorDrawPlacement {
  if (mode === 'normal') return normalPlacement();
  const activeId = document.activeLayerIds[0];
  const active = activeId ? findLayer(document.root, activeId) : undefined;
  const location = active ? findLayerParent(document.root, active.id) : undefined;
  if (!active || !location) return normalPlacement();
  if (mode === 'inside' && (active.kind !== 'vector' || active.clipping || active.vector.objects.length !== 1)) return normalPlacement();
  return {
    parentId: location.parent === document.root ? 'root' : location.parent.id,
    index: mode === 'behind' ? location.index + 1 : location.index,
    clipping: mode === 'inside',
    parentTransform: layerParentTransform(document.root, active.id) ?? IDENTITY_MATRIX,
    effectiveMode: mode,
  };
}

export function transformForPlacement(documentTransform: Matrix, placement: VectorDrawPlacement): Matrix {
  const inverseParent = invertMatrix(placement.parentTransform);
  return inverseParent ? multiplyMatrix(inverseParent, documentTransform) : documentTransform;
}
